import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const HEADING = '#1D228C';

const styles = StyleSheet.create({
    page: { flexDirection: 'row', padding: 0, fontSize: 10, fontFamily: 'Helvetica' },
    verticalBar: { width: 20, backgroundColor: '#002640' },
    left: { width: '30%', padding: 20 },
    right: { width: '70%', padding: 20 },
    name: { fontSize: 18, fontWeight: 'bold', marginBottom: 4 },
    title: { fontSize: 11, marginBottom: 12 },
});

function Template11Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.verticalBar} />
                <View style={styles.left}>
                    <Text style={styles.name}>{name}</Text>
                    <Text style={styles.title}>{title}</Text>
                    <ContactSection email={email} phone={phone} address={address} />
                    <BadgeListSection title="Professional Skills" items={technicalSkills} />
                    <BadgeListSection title="Soft Skills" items={softSkills} />
                    <BadgeListSection title="Languages Known" items={languages} />
                    <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} websiteURL={websiteURL} showSocial={showSocial} />
                </View>
                <View style={styles.right}>
                    <AboutSection about={about} headingColor={HEADING} />
                    <ExperienceSection jobData={jobData} headingColor={HEADING} />
                    <EducationSection educationData={educationData} headingColor={HEADING} />
                    <ReferencesSection referenceData={referenceData} headingColor={HEADING} />
                </View>
            </Page>
        </Document>
    );
}

export default Template11Pdf;